<header>
  <div class="header-bar">
    <div class="header-text">
      Llamada gratuita: 018000 512021 | Bogotá: (031) 291 68 68 | Línea Solidaria: #789
    </div>
  </div>
  <div class="header-content">
    <img src="assets/img/solidaria.png" alt="Logo Aseguradora Solidaria" class="header-logo">
  </div>
</header>
